import { documentAgreementExtraFilesUpdate } from '@/requests/documentAgreement'
import { DocumentAgreementContext } from '../types'

export function useExtraDocuments(context: DocumentAgreementContext) {
  const { documentAgreementId, documentAgreementSource, setDocumentAgreement } =
    context

  const updateExtraFiles = () => {
    return documentAgreementExtraFilesUpdate(
      documentAgreementId.value,
      documentAgreementSource.extraFiles
    ).then(res => {
      setDocumentAgreement(res)
    })
  }

  return { updateExtraFiles }
}
